var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{style:(_vm.styles),attrs:{"color":this.$vuetify.theme.dark ? 'secondary' : 'primary',"fab":"","fixed":"","rel":"noopener","right":"","target":"_blank","top":""},on:{"click":_vm.dark}},[_c('v-icon',[_vm._v(" mdi-vuetify ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }